<core-table [data]="data" [expandableTemplate]="expanded ? taskDetail : undefined" [headers]="headers" class="w-full"/>

<ng-template #taskDescriptionTpl let-item>
  <div class="flex flex-row gap-2 pt-2 pb-2 pl-2 pr-4">
    <input [name]="'task_' + item.id"
           class="w-5 h-5 aspect-square rounded-full appearance-none border-2 border-gray-300 checked:bg-blue-600 checked:border-blue-600 cursor-pointer"
           style="margin-top: 0.2rem"
           type="checkbox"/>
    <div class="flex flex-col">
      <span class="cd-text-b1 text-neutral-800">{{ item.name }}</span>
      <span class="cd-text-b4 font-semibold text-neutral-500">{{ item.description }}</span>
    </div>
  </div>
</ng-template>

<ng-template #taskStatusTagTpl let-item>
  <div class="flex items-center h-full gap-2 flex-wrap">
    @if (item.attachments?.length) {
      <span class="rounded-xl !bg-neutral-200 !py-0 !px-1 cd-text-b4 flex flex-row gap-1 items-center !border-0">
        <img alt="Adjuntos" class="filter-neutral-600 h-4" src="/assets/icons/feather/paperclip.svg">
        <span class="truncate" style="color: var(--color-neutral-600)">Adjuntos ({{ item.attachments?.length }})</span>
      </span>
    }
    @if (item.priority) {
      <span
        [class.outline]="true"
        [class.error]="item.priority === 'high'"
        [class.warning]="item.priority === 'medium'"
        [class.primary]="item.priority === 'low'"
        class="truncate !py-0 !px-1 cd-text-b4">
        Prioridad: {{ getPriorityLabel(item.priority) }}
      </span>
    }
    <span class="outline warning truncate !py-0 !px-1 cd-text-b4">{{ getStatusLabel(item.status) }}</span>
  </div>
</ng-template>

<ng-template #taskDetail let-item>

  <div class="w-full p-4 flex flex-col gap-2 border-1 rounded-lg mt-2" style="border-color: var(--color-neutral-400)">

    <div class=" border-b flex flex-col xl:flex-row gap-2 pb-4"
         style="border-color: var(--color-neutral-200)">
      <div class="flex flex-col md:flex-row gap-2 mr-auto">

        <div class="w-[14rem]">
          <core-datepicker
            [(ngModel)]="getEditModel(item).dateRange"
            (ngModelChange)="handleSave(item)"
            [compact]="true" [range]="true"
            placeholder="01/01/2024 - 05/12/1990">
          </core-datepicker>
        </div>

        <div class="w-[9.5rem]">
          <core-select [labelTemplate]="responsibleSelect"
                       [options]="assigneeOptions"
                       [(ngModel)]="getEditModel(item).assigneeId"
                       (ngModelChange)="handleSave(item)"
                       placeholder="Responsable"/>
        </div>

        <div class="w-[8rem]">
          <core-select [labelTemplate]="prioritySelect"
                       [options]="priorityOptions"
                       [(ngModel)]="getEditModel(item).priority"
                       (ngModelChange)="handleSave(item)"
                       placeholder="Prioridad"/>
        </div>

        <div class="w-[7.5rem]">
          <core-select [labelTemplate]="statusSelect"
                       [options]="statusOptions"
                       [(ngModel)]="getEditModel(item).status"
                       (ngModelChange)="handleSave(item)"
                       placeholder="Estado"/>
        </div>

      </div>

      <core-task-attachments
        [allowUpload]="true"
        [mode]="'button'"
        [task]="item"
        [showInlineList]="false"
        (taskUpdated)="handleAttachmentUpdated($event)"/>
    </div>

    <div class="pt-2">
      <core-task-attachments
        [allowUpload]="true"
        [mode]="'inline'"
        [task]="item"
        [showInlineList]="true"
        (taskUpdated)="handleAttachmentUpdated($event)"/>
    </div>

    <div class="flex flex:col md:flex-row gap-2">

      <button (click)="handleEdit(item)" class="btn btn-primary flex flex-row gap-2 items-center w-fit"
              style="border-radius: 0.5rem;padding: 0.25rem 0.75rem 0.25rem 0.5rem">
        <img alt="Editar" class="filter-neutral-100 h-4" src="/assets/icons/feather/edit.svg">
        <span class="cd-text-md truncate">Editar</span>
      </button>

      <button (click)="handleDelete(item)" class="btn btn-primary-outline flex flex-row gap-2 items-center w-fit"
              style="border-radius: 0.5rem;padding: 0.25rem 0.75rem 0.25rem 0.5rem">
        <img alt="Calendar" class="filter-primary-500 h-4" src="/assets/icons/feather/trash.svg">
        <span class="cd-text-md truncate">Borrar</span>
      </button>

    </div>
  </div>
</ng-template>

<ng-template #responsibleSelect let-option let-placeholder="placeholder">
  <ng-container
    *ngTemplateOutlet="selectLabel; context: { $implicit: { label: option?.label , placeholder, icon: 'user' } }"></ng-container>
</ng-template>

<ng-template #prioritySelect let-option let-placeholder="placeholder">
  <ng-container
    *ngTemplateOutlet="selectLabel; context: { $implicit: { label: option?.label , placeholder, icon: 'flag' } }"></ng-container>
</ng-template>

<ng-template #statusSelect let-option let-placeholder="placeholder">
  <ng-container
    *ngTemplateOutlet="selectLabel; context: { $implicit: { label: option?.label , placeholder, icon: 'flag' } }"></ng-container>
</ng-template>

<ng-template #selectLabel let-context>
  <div class="flex flex-row gap-2 items-center py-1 px-4 border border-neutral-300 rounded-md">
    <img alt="calendar" class="w-4 h-4 filter-neutral-400" src="/assets/icons/feather/{{context.icon}}.svg">
    <span class="cd-text-b3 truncate" style="color: var(--color-neutral-400)">
      {{ context.label || context.placeholder }}
    </span>
  </div>
</ng-template>
